const env = process.env.NODE_ENV;

export const isProduction = env === "production";

export const publicPath = isProduction ? "/tenant/latest" : "";

export const CURRENT_ORGANIZATION_ID_KEY = "CURRENT_ORGANIZATION_ID";

export const apexLocalPath = `localhost:${window.location.port}`;

export const getOperatorApexUrl = () => {
  const { hostname, origin } = window.location;
  const [_tenant] = hostname.split(".");

  return origin.replace(_tenant, "app");
};

export const getOrgPathName = (tenantName?: string) => {
  if(!tenantName) return '/org/app'; //default tenant

  return `/org/${tenantName}`;
}; 

export const getOperatorTenantUrl = (tenantName?: string) => {
  const pathName = getOrgPathName(tenantName);
  return `${window.location.origin}${pathName}`;
}; 